

export class PayRollMessage implements IPayRollMessage {
    message!: string | undefined;

    constructor(data?: IPayRollMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PayRollMessage {
        data = typeof data === 'object' ? data : {};
        let result = new PayRollMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data; 
    }
}

export interface IPayRollMessage {
    message: string | undefined;
}

